module.exports = __webpack_public_path__ + "static/media/Functional.7ca4236a.svg";